import { Component, Input, OnInit } from '@angular/core';

import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { IPeople } from '../../models/IPeople';

@Component({
  selector: 'ff-employee-table',
  templateUrl: './employee-table.component.html',
  styleUrls: ['./employee-table.component.scss']
})
export class EmployeeTableComponent implements OnInit {

  @Input() peopleData:IPeople[];
  
  dataSource = new MatTableDataSource<IPeople>();

  options: FormGroup;
  hideRequiredControl = new FormControl(false);
  floatLabelControl = new FormControl('auto');

  ngOnInit() {
    this.dataSource = new MatTableDataSource<IPeople>(this.peopleData);
  }
  
  constructor(fb: FormBuilder) {
    this.options = fb.group({
      hideRequired: this.hideRequiredControl,
      floatLabel: this.floatLabelControl,
    });

    /**
     * In this sentence it's changed the filter because it's neccesary to search only for name and email
     */
    this.dataSource.filterPredicate = (data: IPeople, filter: string) => 
    (
      data.name.toLocaleLowerCase().includes(filter) || 
      data.email.toLocaleLowerCase().includes(filter)
    );
  }

  displayedColumns: string[] = ['id', 'name', 'status', 'email', 'jobDescription', 'star'];
  
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLocaleLowerCase();
  }

}
